import { useState, useEffect } from 'react';
import { API_URL } from '../../config';
import { useAuth } from '../../context/AuthContext';

const ACTION_MAP = {
  'LOGIN': '系统登录',
  'LOGIN_FAILED': '登录失败',
  'LOGOUT': '系统登出',
  'CREATE_USER': '创建用户',
  'UPDATE_USER': '更新用户',
  'DELETE_USER': '删除用户',
  'CREATE_GROUP': '创建用户组',
  'UPDATE_GROUP': '更新用户组',
  'DELETE_GROUP': '删除用户组',
  'QUOTA_CHANGE': '额度变更',
  'CREATE_TASK': '创建任务',
  'UPDATE_TASK': '更新任务',
  'DELETE_TASK': '删除任务',
  'GENERATE_CONTENT': '执行生成/消耗额度',
  'CREATE_ROLE': '创建角色',
  'UPDATE_ROLE': '更新角色',
  'DELETE_ROLE': '删除角色',
  'ASSIGN_ROLES': '分配角色',
};

const translateDetails = (details) => {
  if (!details) return '-';
  let text = details;
  text = text.replace(/Created user (.*)/i, '创建了用户: $1');
  text = text.replace(/Updated user (.*)/i, '更新了用户: $1');
  text = text.replace(/Created group (.*)/i, '创建了用户组: $1');
  text = text.replace(/Updated group (.*)/i, '更新了用户组: $1');
  text = text.replace(/TOPUP (.*) for Group (.*)/i, '为用户组 $2 增加了 $1 点额度');
  text = text.replace(/REFUND (.*) for Group (.*)/i, '为用户组 $2 扣除了 $1 点额度');
  text = text.replace(/Created task (.*)/i, '创建了任务: $1');
  text = text.replace(/Task (.*) cost (.*)/i, '任务 $1 消耗了 $2 点额度');
  text = text.replace(/Failed login attempt for (.*)/i, '尝试登录失败 (账号: $1)');
  text = text.replace(/Successful login/i, '登录成功');
  return text;
};

export default function Logs() {
  const { token } = useAuth();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      const res = await fetch(`${API_URL}/admin/logs`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.status === 401) { window.location.href = '/login'; return; }
      const data = await res.json();
      setLogs(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100">系统日志 (最近100条)</h1>
      </div>

      <div className="bg-white dark:bg-slate-800/50 border border-gray-100 dark:border-slate-700 rounded-xl shadow overflow-hidden">
        <table className="w-full text-left border-collapse">
          <thead className="bg-gray-50 dark:bg-slate-800/80 border-b border-gray-100 dark:border-slate-700">
            <tr>
              <th className="p-3 text-xs font-semibold text-gray-600 dark:text-gray-400">时间</th>
              <th className="p-3 text-xs font-semibold text-gray-600 dark:text-gray-400">用户</th>
              <th className="p-3 text-xs font-semibold text-gray-600 dark:text-gray-400">操作类型</th>
              <th className="p-3 text-xs font-semibold text-gray-600 dark:text-gray-400">操作详情</th>
              <th className="p-3 text-xs font-semibold text-gray-600 dark:text-gray-400">IP地址</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 dark:divide-slate-700">
            {logs.map(log => (
              <tr key={log.id} className="hover:bg-gray-50 dark:hover:bg-slate-700/30 text-xs">
                <td className="p-3 text-gray-500 whitespace-nowrap">
                  {new Date(log.createdAt).toLocaleString()}
                </td>
                <td className="p-3 font-medium text-gray-900 dark:text-gray-200">
                  {log.user ? `${log.user.name} (${log.user.email})` : 'System/Unknown'}
                </td>
                <td className="p-3">
                  <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-300">
                    {ACTION_MAP[log.action] || log.action}
                  </span>
                </td>
                <td className="p-3 text-gray-600 dark:text-gray-400 max-w-md truncate" title={translateDetails(log.details)}>
                  {translateDetails(log.details)}
                </td>
                <td className="p-3 text-gray-500">{log.ip || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
